<template>
  <div class="">
    <div class="card">
      <div class="card-body">
        <h4
          class="card-title"
          :class="$i18n.locale == 'ar' ? 'hacen_algeria' : 'txt-left'"
        >
          {{ label }}
        </h4>

        <div class="tab-danger pt-3">
          <!-- Nav Tabs -->
          <ul v-if="$i18n.locale == 'ar'" class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <a
                href="#tab-arabic"
                class="nav-link"
                role="tab"
                data-toggle="tab"
                aria-selected="true"
                :class="
                  $i18n.locale == 'ar'
                    ? 'hacen_algeria font-size-15 active show'
                    : ''
                "
              >
                {{ $t("app.arabic") }}
              </a>
            </li>
            <li class="nav-item">
              <a
                href="#tab-english"
                class="nav-link"
                role="tab"
                data-toggle="tab"
                aria-selected="false"
                :class="
                  $i18n.locale == 'ar'
                    ? 'hacen_algeria font-size-15'
                    : 'active show'
                "
              >
                {{ $t("app.english") }}
              </a>
            </li>
          </ul>
          <ul v-if="$i18n.locale == 'en'" class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <a
                href="#tab-english"
                class="nav-link"
                role="tab"
                data-toggle="tab"
                aria-selected="false"
                :class="
                  $i18n.locale == 'ar'
                    ? 'hacen_algeria font-size-15'
                    : 'active show'
                "
              >
                {{ $t("app.english") }}
              </a>
            </li>
            <li class="nav-item">
              <a
                href="#tab-arabic"
                class="nav-link"
                role="tab"
                data-toggle="tab"
                aria-selected="true"
                :class="
                  $i18n.locale == 'ar'
                    ? 'hacen_algeria font-size-15 active show'
                    : ''
                "
              >
                {{ $t("app.arabic") }}
              </a>
            </li>
          </ul>
          <!-- End Nav Tabs -->

          <!-- Tab Panels -->
          <div class="tab-content">
            <div
              role="tabpanel"
              class="tab-pane fade pt-3"
              :class="$i18n.locale == 'ar' ? 'active show' : ''"
              id="tab-arabic"
            >
              <!-- Title -->
              <div v-if="hasTitle" class="form-group col-12">
                <label
                  for="inputAR1"
                  class="col-form-label"
                  :class="
                    $i18n.locale == 'ar'
                      ? 'hacen_algeria font-size-15'
                      : 'float-left'
                  "
                >
                  {{ labelTitle }}
                </label>
                <input
                  id="inputAR1"
                  type="text"
                  class="form-control"
                  :class="
                    $i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''
                  "
                  v-model="row.title_ar"
                  v-on:input="onFormChange"
                />
              </div>
              <!-- End Title -->

              <!-- Position -->
              <div v-if="hasPosition" class="form-group col-12">
                <label
                  for="inputARTY1"
                  class="col-form-label"
                  :class="
                    $i18n.locale == 'ar'
                      ? 'hacen_algeria font-size-15'
                      : 'float-left'
                  "
                >
                  {{ labelPosition }}
                </label>
                <input
                  id="inputARTY1"
                  type="text"
                  class="form-control"
                  :class="
                    $i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''
                  "
                  v-model="row.position_ar"
                  v-on:input="onFormChange"
                />
              </div>
              <!-- End Position -->

              <!-- Mobile + Country Code -->
              <div v-if="hasMobile" class="form-group row px-2">
                <!-- country_code -->
                <div class="col-3">
                  <label
                    for="inputCountryCode"
                    class="col-form-label"
                    :class="$i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : 'float-left'"
                  >
                    {{ labelCountryCode }}
                  </label>
                  <input
                    id="inputCountryCode"
                    type="text"
                    class="form-control"
                    :class="$i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''"
                    v-model="row.country_code"
                    v-on:input="onFormChange"
                  />
                </div>

                <!-- mobile -->
                <div class="col-9">
                  <label
                    for="inputMobile"
                    class="col-form-label"
                    :class="$i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : 'float-left'"
                  >
                    {{ labelMobile }}
                  </label>
                  <input
                    id="inputMobile"
                    type="number"
                    class="form-control"
                    :class="$i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''"
                    v-model="row.mobile"
                    v-on:input="onFormChange"
                  />
                </div>
              </div>
              <!-- End Mobile + Country Code -->

              <!-- social links -->
              <div v-if="hasSocial" class="form-group row px-2">
                <!-- facebook_link -->
                <div class="col-6">
                  <label
                    for="inputFacebookLink"
                    class="col-form-label"
                    :class="$i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : 'float-left'"
                  >
                    {{ labelFacebookLink }}
                  </label>
                  <input
                    id="inputFacebookLink"
                    type="text"
                    class="form-control"
                    :class="$i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''"
                    v-model="row.facebook_link"
                    v-on:input="onFormChange"
                  />
                </div>

                <!-- twitter_link -->
                <div class="col-6">
                  <label
                    for="inputTwitterLink"
                    class="col-form-label"
                    :class="$i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : 'float-left'"
                  >
                    {{ labelTwitterLink }}
                  </label>
                  <input
                    id="inputTwitterLink"
                    type="text"
                    class="form-control"
                    :class="$i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''"
                    v-model="row.twitter_link"
                    v-on:input="onFormChange"
                  />
                </div>
              </div>
              <!-- social -->


              <!-- University -->
              <div v-if="hasUniversity" class="form-group col-12">
                <label
                  for="inputARMO1"
                  class="col-form-label"
                  :class="
                    $i18n.locale == 'ar'
                      ? 'hacen_algeria font-size-15'
                      : 'float-left'
                  "
                >
                  {{ labelUniversity }}
                </label>
                <input
                  id="inputARMO1"
                  type="text"
                  class="form-control"
                  :class="
                    $i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''
                  "
                  v-model="row.university_ar"
                  v-on:input="onFormChange"
                />
              </div>
              <!-- End University -->

              <!-- Body -->
              <div v-if="hasBody" class="form-group col-12">
                <label
                  for="editorAR1"
                  class="col-form-label"
                  :class="
                    $i18n.locale == 'ar'
                      ? 'hacen_algeria font-size-15'
                      : 'float-left'
                  "
                >
                  {{ labelBody }}
                </label>
                <div v-if="$i18n.locale == 'en'" class="col-12">
                  <br /><br />
                </div>
                <editor
                  id="editorAR1"
                  v-model="row.body_ar"
                  v-on:input="onFormChange"
                  :api-key="editor.api_key"
                  :init="{
                    height: 300,
                    menubar: editor.menubar,
                    plugins: editor.plugins,
                    toolbar: editor.toolbar,
                  }"
                />
              </div>
              <!-- End Body -->
            </div>

            <div
              role="tabpanel"
              class="tab-pane fade in pt-3"
              :class="$i18n.locale == 'ar' ? '' : 'active show'"
              id="tab-english"
            >
              <!-- Title -->
              <div v-if="hasTitle" class="form-group col-12">
                <label
                  for="inputEN1"
                  class="col-form-label"
                  :class="
                    $i18n.locale == 'ar'
                      ? 'hacen_algeria font-size-15'
                      : 'float-left'
                  "
                >
                  {{ labelTitle }}
                </label>
                <input
                  id="inputEN1"
                  type="text"
                  class="form-control"
                  style="direction: ltr"
                  :class="
                    $i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''
                  "
                  v-model="row.title_en"
                  v-on:input="onFormChange"
                />
              </div>
              <!-- End Title -->

              <!-- Position -->
              <div v-if="hasPosition" class="form-group col-12">
                <label
                  for="inputENTY1"
                  class="col-form-label"
                  :class="
                    $i18n.locale == 'ar'
                      ? 'hacen_algeria font-size-15'
                      : 'float-left'
                  "
                >
                  {{ labelPosition }}
                </label>
                <input
                  id="inputENTY1"
                  type="text"
                  class="form-control"
                  style="direction: ltr"
                  :class="
                    $i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''
                  "
                  v-model="row.position_en"
                  v-on:input="onFormChange"
                />
              </div>
              <!-- End Position -->

              <!-- University -->
              <div v-if="hasUniversity" class="form-group col-12">
                <label
                  for="inputENMO1"
                  class="col-form-label"
                  :class="
                    $i18n.locale == 'ar'
                      ? 'hacen_algeria font-size-15'
                      : 'float-left'
                  "
                >
                  {{ labelUniversity }}
                </label>
                <input
                  id="inputENMO1"
                  type="text"
                  class="form-control"
                  style="direction: ltr"
                  :class="
                    $i18n.locale == 'ar' ? 'hacen_algeria font-size-15' : ''
                  "
                  v-model="row.university_en"
                  v-on:input="onFormChange"
                />
              </div>
              <!-- End University -->

              <!-- Body -->
              <div v-if="hasBody" class="form-group col-12">
                <label
                  for="editorEN1"
                  class="col-form-label"
                  :class="
                    $i18n.locale == 'ar'
                      ? 'hacen_algeria font-size-15'
                      : 'float-left'
                  "
                >
                  {{ labelBody }}
                </label>
                <div v-if="$i18n.locale == 'en'" class="col-12">
                  <br /><br />
                </div>
                <editor
                  id="editorEN1"
                  v-model="row.body_en"
                  v-on:input="onFormChange"
                  :api-key="editor.api_key"
                  :init="{
                    height: 300,
                    menubar: editor.menubar,
                    plugins: editor.plugins,
                    toolbar: editor.toolbar,
                  }"
                />
              </div>
              <!-- End Body -->
            </div>
          </div>
          <!-- End Tab Panels -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";

export default {
  name: "FormElements",
  components: {
    Editor,
  },
  props: [
    "label",
    "labelTitle",
    "labelPosition",
    "labelCountryCode",
    "labelMobile",
    "labelFacebookLink",
    "labelTwitterLink",
    "labelUniversity",
    "labelBody",

    "hasTitle",
    "hasPosition",
    "hasMobile",
    "hasSocial",
    "hasUniversity",
    "hasBody",

    "title_ar",
    "title_en",

    "position_ar",
    "position_en",

    "university_ar",
    "university_en",

    "country_code",
    "mobile",
    "facebook_link",
    "twitter_link",

    "body_ar",
    "body_en",
  ],
  data() {
    return {
      row: {
        title_ar: this.$props.title_ar,
        title_en: this.$props.title_en,

        position_ar: this.$props.position_ar,
        position_en: this.$props.position_en,

        country_code: this.$props.country_code,
        mobile: this.$props.mobile,
        facebook_link: this.$props.facebook_link,
        twitter_link: this.$props.twitter_link,

        university_ar: this.$props.university_ar,
        university_en: this.$props.university_en,

        body_ar: this.$props.body_ar,
        body_en: this.$props.body_en,
      },

      editor: {
        api_key: window.editor_apiKey,
        menubar: window.editor_menubar,
        plugins: window.editor_plugins,
        toolbar: window.editor_toolbar,
      },
    };
  },
  mounted() {},
  methods: {
    onFormChange() {
      const data = {
        title_ar: this.row.title_ar,
        title_en: this.row.title_en,

        position_ar: this.row.position_ar,
        position_en: this.row.position_en,

        country_code: this.row.country_code,
        mobile: this.row.mobile,
        facebook_link: this.row.facebook_link,
        twitter_link: this.row.twitter_link,

        university_ar: this.row.university_ar,
        university_en: this.row.university_en,

        body_ar: this.row.body_ar,
        body_en: this.row.body_en,
      };
      this.$emit("formChange", data);
    },
  },
};
</script>
